import { z } from "zod";

//ObraEstruturaTreinamentoSchema


export const ObraEstruturaTreinamentoSchema = z.object({
  cargo: z.string({ required_error: 'Este campo deve ser preenchido!' }),
  TIPO_TREINAMENTO: z.string({ required_error: 'Este campo deve ser preenchido!' }),
});

//ObraEstruturaTreinamentoForm

export type ObraEstruturaTreinamentoForm = z.infer<typeof ObraEstruturaTreinamentoSchema>;